import intl from "react-intl-universal";
export var signStatus = {
    Signed: intl.get("Signed"),
    Not_Signed: intl.get("Not_Signed"),
    Signed_NoPDF: intl.get("Signed_NoPDF"),
};
export var pdfType = {
    Claim: intl.get("Claim"),
    Invoice: intl.get("Invoice"),
};
export var pcOptions = [
    {
        label: "中文",
        value: "zh",
        span: "CH",
    },
    {
        label: "英文",
        value: "en",
        span: "EN",
    },
];
export var mobileOptions = [
    {
        label: "中文",
        value: "zh",
    },
    {
        label: "English",
        value: "en",
        disabled: true,
    },
];
